<template>
	<div class="container-fluid">
		
		<div class="card py-2 text-center" v-if="from!='dataset'">
			<span v-if="dataset.data" class="mr-2">					
				<span class="float-right badge badge-warning" v-if="dataset.data[dataset.files[0]].out_error">{{dataset.data[dataset.files[0]].out_error}}</span>
				<span class="float-right badge badge-info" v-else>{{dataset.data[dataset.files[0]].data}} entries</span>
			</span>
			<h5 class="text-center">{{dataset.name}}<br><small>{{dataset.description}}</small></h5>
			<ul class="list-unstyled" style="font-style:italic;color:grey">
				<li v-for="data in dataset.data">{{data.file}}</li>
			</ul>
		</div>
		
		<div class="card mt-3 py-2" v-if="dataset.matrix">
			<h5 class="text-center pointer" @click="hideAction('description')">
				<span class="mr-2"><v-icon v-if="hide.description" class="align-middle" name="chevron-right"></v-icon><v-icon v-else class="align-middle" name="chevron-down"></v-icon></span>
				Description of the dataset ({{dataset.matrix_headers.length}} fields, {{dataset.matrix_nb}} entries)
			</h5>
			<div class="row" v-if="!hide.description">
				<div class="col-6">
					<p class="text-center">
						<b>Variable fields : </b>
					</p>
					<ul class="mt-3">
						<li v-for="(variable,fidx) in dataset.variables"><strong>{{variable.name}}</strong> : 
							<ul v-if="variable.values.length!=dataset.matrix.length">
								<li v-for="(val,vidx) in variable.values">{{val}}</li>
							</ul>
							<span v-else>{{variable.values.length}} different values</span>
						</li>
					</ul>
				</div>
				<div class="col-6">
					<b>Fixed fields : </b>
					<ul class="mt-3">
						<li v-for="(fixed_field,fidx) in dataset.fixed"><strong>{{fixed_field.name}}</strong> : {{fixed_field.value}}</li>
					</ul>					
				</div>
			</div>
		</div>
		
		<!-- <div class="card mt-3 py-2" v-if="dataset.data && from =='dataset'">
			<h5 class="text-center">Data</h5>
			<select class="form-control" style="display:inline-flex;width:500px" v-model="current_data"><option v-for="d in dataset.files">{{d}}</option></select>
			<p class="mt-3 mx-5 py-3 text-center alert-warning" v-if="dataset.data[current_data].out_error">{{dataset.data[current_data].out_error}}</p>
			<p class="mt-3 mx-5 py-3 text-center alert-info" v-else>{{dataset.data[current_data].data}} entries</p>
		</div> -->
	</div>
</template>

<script>	
import { mapGetters } from 'vuex';
export default {
	name: 'DatasetDetails',
	props:['from','datasetId'],
	data () {
		return {
			idx:0,
			current_data:null,
			hide:{description:false}
		}
	},
	computed:{
		...mapGetters({
			currentUser: 'currentUser',
			dataset:'dataset'
		})
	},
	methods:{
		hideAction(cas){
			let _this = this;
			_this.$set(_this.hide,cas,!_this.hide[cas]);
		}
	},
	mounted() {
		var _this = this;
		var dataset_id = (_this.from=='dataset') ? _this.datasetId : _this.$route.params.dataset_id;
		_this.$store.dispatch('getDataset',dataset_id);
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
	font-weight: normal;
}
a {
	color: #42b983;
}
</style>
